import { Divider, Group, Stack, Text } from '@mantine/core'

import { FormattedSlugTiming } from './helpers'
import { TimingBreakdown } from './TimingBreakdown'

import styles from './SlugTiming.module.css'

export const SlugTiming = ({
  slugTimings,
  maxHeight,
}: {
  slugTimings: Array<FormattedSlugTiming>
  maxHeight: number
}) => {
  const formattedSlugs = slugTimings.map((slug, idx: number) => {
    const title = slug.isBlank ? 'SLUG' : slug.title.toUpperCase()

    return (
      <Stack
        className={styles.stack}
        data-variant={slug.isBlank ? 'blank' : 'populated'}
        key={String(idx) + '-' + title}
        gap={5}
        pt={0}
        pb={5}
      >
        <Stack gap={5} px={10} pt={5}>
          <Group justify="space-between" wrap="nowrap">
            <Text>{title}</Text>
            <Text>{slug.total}</Text>
          </Group>
          <Divider className={styles.divider} />
          <TimingBreakdown dialogue={slug.dialogue} bracket={slug.bracket} />
        </Stack>
      </Stack>
    )
  })

  return (
    <div style={{ maxHeight }} className={styles.scroll}>
      {formattedSlugs}
    </div>
  )
}
